'use client';

import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';

export default function ScrollToRooms() {
  const params = useSearchParams();

  useEffect(() => {
    if (!params.get('checkin') && !params.get('checkout')) return;
    const el = document.getElementById('rooms-list');
    if (!el) return;
    // Small delay lets the page paint before scrolling
    const t = setTimeout(() => {
      const rootPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
      const stickyLayer = document.querySelector('header')?.children[1] as HTMLElement | undefined;
      const navH = stickyLayer?.getBoundingClientRect().bottom ?? 7.6 * rootPx;

      const sentinel = document.querySelector('[data-avail-sentinel]') as HTMLElement | null;
      const compactH = sentinel ? parseFloat(sentinel.getAttribute('data-compact-h') ?? '0') : 0;

      const widget = document.querySelector('[data-avail-widget]') as HTMLElement | null;
      const widgetFixed = widget ? getComputedStyle(widget).position === 'fixed' : false;
      let roomsAbsTop = el.getBoundingClientRect().top + window.scrollY;
      if (!widgetFixed && widget) {
        const delta = Math.max(0, widget.offsetHeight - compactH);
        roomsAbsTop -= delta;
      }

      window.scrollTo({ top: roomsAbsTop - navH - compactH - 16, behavior: 'smooth' });
    }, 120);
    return () => clearTimeout(t);
  }, [params]);

  return null;
}
